export const SET_DATA_PRODUCT_FOR_EDIT = 'SET_DATA_PRODUCT_FOR_EDIT';
export const setDataProductForEdit = (dataProductForEdit) => (
  {
    type: SET_DATA_PRODUCT_FOR_EDIT,
    dataProductForEdit
  }
);
export const SET_MESSAGE_SAVE_STATE_PRODUCT = 'SET_MESSAGE_SAVE_STATE_PRODUCT';
export const setMessageSaveStateProduct = (messageSaveStateProduct) => (
  {
    type: SET_MESSAGE_SAVE_STATE_PRODUCT,
    messageSaveStateProduct
  }
);
export const SET_FILTER_TEXT_SEARCH_PRODUCT = 'SET_FILTER_TEXT_SEARCH_PRODUCT';
export const setFilterTextSearchProduct = (filterTextSearchProduct) => (
  {
    type: SET_FILTER_TEXT_SEARCH_PRODUCT,
    filterTextSearchProduct
  }
);
export const SET_FILTER_TYPE_CATEGORY = 'SET_FILTER_TYPE_CATEGORY';
export const setFilterTypeCategory = (filterTypeCategory) => (
  {
    type: SET_FILTER_TYPE_CATEGORY,
    filterTypeCategory
  }
);
export const SET_AVAILABLE_OFFSET_SEARCH_PRODUCT = 'SET_AVAILABLE_OFFSET_SEARCH_PRODUCT';
export const setAvailableOffsetSearchProduct = (availableOffsetSearchProduct) => (
  {
    type: SET_AVAILABLE_OFFSET_SEARCH_PRODUCT,
    availableOffsetSearchProduct
  }
);
export const SET_ORIGIN_REQUEST_LIST = 'SET_ORIGIN_REQUEST_LIST';
export const setOriginRequestList = (originRequestList) => (
  {
    type: SET_ORIGIN_REQUEST_LIST,
    originRequestList
  }
);
export const SET_MESSAGE_PRODUCT_STATE = 'SET_MESSAGE_PRODUCT_STATE';
export const setMessageProductState = (messageProductState) => (
  {
    type: SET_MESSAGE_PRODUCT_STATE,
    messageProductState
  }
);